<script lang="ts">
	//Components
	import BleInclusion from './BleInclusion.svelte';
	import WiFiInputForm from './WifiCredentialsFormComponents/WiFiInputForm.svelte';
	import InclusionError from './InclusionError.svelte';
	import InclusionLoader from './WifiCredentialsFormComponents/InclusionLoader.svelte';
	import AuthenticateBleDevices from './AuthenticateBleDevices.svelte';
	import { authenticateGen2DeviceModal } from 'src/stores/device-runtime/firmware-ui';
	import { createEventDispatcher } from 'svelte';

	export let inclusionData, isOpen;

	$: isScanOpen = false;

	const dispatch = createEventDispatcher();
</script>

{#if inclusionData?.selectVia == 'ble' && inclusionData?.selected?.gen == 'GBLE'}
	<BleInclusion bind:inclusionData />
{:else if inclusionData.running && !inclusionData?.error}
	<InclusionLoader bind:inclusionData />
{:else if inclusionData.error}
	<InclusionError bind:inclusionData />
{:else}
	<WiFiInputForm bind:inclusionData bind:isOpen bind:isScanOpen />
{/if}

{#if typeof $authenticateGen2DeviceModal !== 'undefined'}
	<!-- unlocking authentication locked devices over bluetooth -->
	<AuthenticateBleDevices bind:isScanOpen on:save={() => dispatch('save')} />
{/if}
